<zwi-call-to-action>
  <ng-container title>Verify your email address for your Zwiloo account.</ng-container>
  <ng-container content>A verification email was sent to {{ email }}. If you don't see it, check your spam or junk folder.</ng-container>
</zwi-call-to-action>
